import $ from 'jquery'

import Alerts from './alerts'
import FormState from './form-state'

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME = 'formasync'
const DATA_KEY = `opp.${NAME}`
const EVENT_KEY = '.' + DATA_KEY

const Event = {
  ERROR: 'error' + EVENT_KEY,
  SUCCESS: 'success' + EVENT_KEY,
  COMPLETE: 'complete' + EVENT_KEY,
  RESETTING: 'resetting' + EVENT_KEY,
  SUBMITTING: 'submitting' + EVENT_KEY
}

const Selector = {
  DATA_FORM_ASYNC: '[data-form="async"]',
  HIDDEN_CHARSET: '[name=_charset_]'
}

/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class FormAsync {
  // Getters

  static get Selector() {
    return Selector
  }

  static get Event() {
    return Event
  }
}

// TODO convert the functions below into methods of the FormAsync class
// to match the style of bootstrap

function getData($el) {
  return $el.data(DATA_KEY, $el.data(DATA_KEY) || {}).data(DATA_KEY)
}

function updateDefaultVal() {
  const $el = $(this)
  const data = getData($el)
  data.defaultVal = $el.val()
  return $el
}

function restoreDefaultVal() {
  const $el = $(this)
  const data = getData($el)
  if ('defaultVal' in data) {
    $el.val(data.defaultVal)
  }

  return $el
}

function findFormInputs() {
  return $($(this).filter('form').prop('elements'))
    .find(':input').addBack().filter(':input')
    .not(Selector.HIDDEN_CHARSET)
}

function updateFormDefaults() {
  const elems = findFormInputs.call(this)
  elems.each(updateDefaultVal)
  FormState.update(this, true /* clean */)
  return elems
}

function restoreFormDefaults() {
  const elems = findFormInputs.call(this)
  elems.each(restoreDefaultVal)
  FormState.update(this, true /* clean */)
  return elems
}

function alertError() {
  Alerts.trigger(this, $(this).text(), 'danger')
}

function onAjaxError(xhr, status) {
  const $form = $(this)
  // Ignore events not caused by current xhr
  if (xhr === getData($form).xhr) {
    $form.trigger(Event.ERROR, xhr, status)
    $form.find('[data-alert="error"]').each(alertError)
  }
}

function alertSuccess() {
  Alerts.trigger(this, $(this).text(), 'success')
}

function onAjaxSuccess(data, status, xhr) {
  const $form = $(this)
  // ignore events not caused by current xhr
  if (xhr === getData($form).xhr) {
    $form.trigger(Event.SUCCESS, xhr, status, data)
    $form.find('[data-alert="success"]').each(alertSuccess)
  }
}

function onAjaxComplete(xhr, status) {
  const $form = $(this)
  const data = getData($form)
  // cleanup to avoid holding reference to completed XHR
  if (data.xhr === xhr) {
    delete data.xhr
  }

  // trigger event on form
  $form.trigger(Event.COMPLETE, xhr, status)
}

function postForm() {
  const $form = $(this)
  const data = getData($form)

  // Abort previous request to avoid network race
  if (data.xhr) {
    const { xhr } = data
    // Delete xhr to suppress error message
    delete data.xhr
    xhr.abort()
  }

  // Post FormData and stash XHR so it can be aborted, if necessary
  data.xhr = $.ajax({
    type: $form.getProp('method', { type: 'string' }),
    url: $form.getProp('action', { type: 'string' }),
    data: new FormData(this),
    context: this,
    processData: false,
    contentType: false,
    error: onAjaxError,
    success: onAjaxSuccess,
    complete: onAjaxComplete
  })
}

function hideModal() {
  $($(this).data('modal')).modal('hide')
}

function onFormSubmit(evt) {
  hideModal.call(this)
  // N.B. trigger evt first so listener can prepare
  $(this).trigger(Event.SUBMITTING)
  updateFormDefaults.call(this)
  postForm.call(this)
  evt.preventDefault()
  return false
}

function onFormReset(evt) {
  // N.B. trigger evt first so listener can prepare
  $(this).trigger(Event.RESETTING)
  restoreFormDefaults.call(this)
  evt.preventDefault()
  return false
}

function ensureHiddenCharsetInput() {
  // Ensure that form includes hidden _charset_ input, which will be populated
  // by the browser before the XHR is sent. This can be used on the server to
  // correctly detect the character encoding without prior coordination.
  const $form = $(this).filter('form')
  if ($form.find(Selector.HIDDEN_CHARSET).length < 1) {
    $form.append('<input type="hidden" name="_charset_">')
  }
}

function init() {
  // N.B. reset form first, to ignore form-state persisted and restored by browser.
  this.reset()
  ensureHiddenCharsetInput.call(this)
  updateFormDefaults.call(this)
}

// N.B. forms inserted after this point need to be initialized manually for
// reset to work as expected prior to form submission.
$(Selector.DATA_FORM_ASYNC).each(init)

$(document)
  .on('submit', Selector.DATA_FORM_ASYNC, onFormSubmit)
  .on('reset', Selector.DATA_FORM_ASYNC, onFormReset)

export default FormAsync
